var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-page"},[_c('div',[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo,"width":"240","loading":"lazy","alt":"OnBord","id":"companyLogo"}})]),_c('h2',[_vm._v("Statement Submitted")]),_c('h3',[_vm._v(" You will receive further communication from your advisor to transition your accounts ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }